// Mappa CAP -> codice zona (Milano: 006, 007, 016 - Alessandria: 368)
export const ZONE_BY_CAP: Record<string, string> = {
  '20121': '006',
  '20122': '006',
  '20124': '006',
  '20129': '006',
  '20131': '006',
  '20133': '006',
  '20134': '006',
  '20135': '006',
  '20137': '006',
  '20138': '006',
  '20159': '006',

  '20123': '007',
  '20136': '007',
  '20139': '007',
  '20141': '007',
  '20142': '007',
  '20143': '007',
  '20144': '007',
  '20145': '007',
  '20146': '007',
  '20147': '007',
  '20148': '007',
  '20149': '007',
  '20151': '007',
  '20152': '007',
  '20153': '007',
  '20154': '007',
  '20155': '007',
  '20156': '007',
  '20157': '007',
  '20158': '007',

  '20125': '016',
  '20126': '016',
  '20127': '016',
  '20128': '016',
  '20132': '016',
  '20161': '016',
  '20162': '016',

  '15010': '368',
  '15011': '368',
  '15012': '368',
  '15013': '368',
  '15015': '368',
  '15016': '368',
  '15017': '368',
  '15018': '368',
  '15019': '368',
  '15020': '368',
  '15021': '368',
  '15022': '368',
  '15023': '368',
  '15024': '368',
  '15025': '368',
  '15026': '368',
  '15027': '368',
  '15028': '368',
  '15029': '368',
  '15030': '368',
  '15031': '368',
  '15032': '368',
  '15033': '368',
  '15034': '368',
  '15035': '368',
  '15036': '368',
  '15038': '368',
  '15039': '368',
  '15040': '368',
  '15041': '368',
  '15042': '368',
  '15043': '368',
  '15044': '368',
  '15045': '368',
  '15046': '368',
  '15048': '368',
  '15049': '368',
  '15050': '368',
  '15051': '368',
  '15052': '368',
  '15053': '368',
  '15054': '368',
  '15055': '368',
  '15056': '368',
  '15057': '368',
  '15058': '368',
  '15059': '368',
  '15060': '368',
  '15061': '368',
  '15062': '368',
  '15063': '368',
  '15064': '368',
  '15065': '368',
  '15066': '368',
  '15067': '368',
  '15068': '368',
  '15069': '368',
  '15070': '368',
  '15071': '368',
  '15072': '368',
  '15073': '368',
  '15074': '368',
  '15075': '368',
  '15076': '368',
  '15077': '368',
  '15078': '368',
  '15079': '368',
  '15121': '368',
  '15122': '368',
};
